// types.ts
import type { IconType } from '@ais-ui/ui-core';

export enum TokenType {
  Field = 'Field',
  ArithmeticOperator = 'ArithmeticOperator',
  Value = 'Value',
  LogicalOperator = 'LogicalOperator',
}

export interface Token {
  type: 'field' | 'operator' | 'value' | 'logical' | 'parenthesis';
  value: string;
  start: number;
  end: number;
  raw: string;
}

export interface Suggestion {
  type: 'field' | 'operator' | 'value' | 'logical';
  value: string;
  label: string;
  icon: IconType | null;
  description: string | null;
  isHint?: boolean; // New property to identify hints vs actual suggestions
  noQuotes?: boolean; // Flag to indicate this value should not be wrapped in quotes
}

/**
 * A named area/circle that can be offered as a value for position fields.
 * Providers (e.g. an app's shapes list) map their data to this shape.
 */
export interface FilterAreaValue {
  id: string | undefined;
  name: string | undefined;
  type: string;
  geometryType: string;
  coordinates?: number[];
  radius?: number;
}

export interface TokenizerResult {
  tokens: Token[];
  currentToken: Token | null;
  expectedNext: TokenType;
  cursorContext: {
    insideToken: boolean;
    tokenIndex: number;
    positionInToken: number;
  } | null;
}
